import { useEffect } from 'react';

export function useUnsavedChangesPrompt(shouldPrompt: boolean) {
  useEffect(() => {
    if (!shouldPrompt) {
      return;
    }

    const handler = (event: BeforeUnloadEvent) => {
      event.preventDefault();
    };

    window.addEventListener('beforeunload', handler);

    // eslint-disable-next-line consistent-return
    return () => window.removeEventListener('beforeunload', handler);
  }, [shouldPrompt]);
}
